import React, { Component } from 'react'
import Swiper from 'swiper'
import { Input, Modal } from 'antd'
import ExternalFiles from '../../component/externalFiles'
import TipsDialog from '../../component/dialog'
import ConnectUs from '../../component/connect'
import CountrySelect from '../../component/countrySelect'
import RegisterErWeiMa from '../../../../assets/erweima.png'
import RegisterManaul from '../../../../assets/registericon.png'
import DelIcon from '../../../../assets/ico-delete.png'
import CloseIcon from '../../../../assets/ico-close.png'
import GeetestCaptcha from '../../component/captcha'
import { validateMobile, getCookie, setCookie } from '../../../../util/utils'
import WarnIcon from '../../../../assets/warn.png'
import { sendVerifyCodeNew, verifyCodeNewValid, checkPhoneEmailValid, wechatCode,wechatCodeValid } from '../../../../service/index'
import intl from 'react-intl-universal'
import '../../base.less'
import './index.less'
import "swiper/css/swiper.css";
class Register extends Component {
	constructor(props) {
		super(props)
		this.captchaConfig = {
			config: {
				captchaId: "56953b22f02a8c7f4f134733e177b252",
				language: getCookie('seller_site_lang') ? getCookie('seller_site_lang').split('-')[0] == 'zh' ? 'zho' : 'eng' : 'zho',
				product: "bind",
				protocol: "https://"
			},
			handler: this.captchaHandler.bind(this)
		}
		this.state = {
			registerVisible: false,
			focusFlag: '',
			registerType: 'manaul',
			sendVerity: 0,
			verityTime: 60,
			countryAreacode: '+86',
			countryCode: 'CN',
			phone: '',
			phoneErrTips: '',
			modalVisible: false,
			limitFlag: '0',
			limitType: '',
			limitNum: 0,
			registerWarnTips: '',
			verityCode: '',
			verityCodeErrTips: '',
			noverityVisible: false,
			chatImg: '',
			bannerData: [{
				imageUrl: '//www.dhresource.com/dhs/oth/slp/20210827/banner1.png',
				imageUrlEn: '//www.dhresource.com/dhs/oth/slp/20210827/banner1-en.png',
				linkUrl: 'https://seller.dhgate.com//story/c_113355.html#story-tab1-2'
			}, {
				imageUrl: '//www.dhresource.com/dhs/oth/slp/20210827/banner2.png',
				imageUrlEn:'//www.dhresource.com/dhs/oth/slp/20210827/banner2-en.png',
				linkUrl: 'https://seller.dhgate.com//story/c_113361.html'
			}, {
				imageUrl: '//www.dhresource.com/dhs/oth/slp/20210827/banner3.png',
				imageUrlEn: '//www.dhresource.com/dhs/oth/slp/20210827/banner3-en.png',
				linkUrl: 'https://seller.dhgate.com/story/c_46400.html#cms_storychuangye-list-12'
			}],
			isColumbusSeller: false
		}
		this.handleRegisterBtnClick = this.handleRegisterBtnClick.bind(this)
		this.handleSendVerityCodeBtnClick = this.handleSendVerityCodeBtnClick.bind(this)
		this.handleLoginBtnClick = this.handleLoginBtnClick.bind(this)
		this.handleCountryChange = this.handleCountryChange.bind(this)
		this.handleModalClose = this.handleModalClose.bind(this)
		this.handleNoverityCodeClick = this.handleNoverityCodeClick.bind(this)
		this.handleVerityModalClose = this.handleVerityModalClose.bind(this)
	}

	handleNoverityCodeClick() {
		this.setState({
			noverityVisible: true
		})
	}

	handleVerityModalClose() {
		this.setState({
			noverityVisible: false
		})
	}

	handleCountryChange(val) {
		this.setState({
			countryCode: val.split('-')[1],
			countryAreacode: val.split('-')[0],
			isColumbusSeller: val.split('-')[1]=='US'?true:false
		}, () => {
			const { phone } = this.state
			if(phone){
				this.chkPhone()
			}
			
		})
	}

	handleRegisterBtnClick() {
		const { phone, verityCode, countryCode } = this.state
		const params = new FormData()
		params.append('phone', phone)
		params.append('checkCode', verityCode)
		params.append('countryCode', countryCode)
		verifyCodeNewValid(params).then(res => {
			if (res.flag) {
				window.open(`//seller.dhgate.com/sellerextend/html/black/registerPageload2${window.location.search}`, '_self')
			} else {
				this.setState({
					verityCodeErrTips: res.msg
				})
			}
		}).catch(err => err)
	}

	handleLoginBtnClick() {
		window.open('https://secure.dhgate.com/passport/login?service=http%3A%2F%2Fseller.dhgate.com%2Fmerchant%2Flogin%2Fssologin.do%3FreturnUrl%3DaHR0cDovL3NlbGxlci5kaGdhdGUuY29tL21lcmNoYW50L2xvZ2luL2xvZ2luc2lnbi5kbw..#hp-head-1', '_self')
	}

	captchaHandler(captchaObj) {
		window.captchaObj = captchaObj
		captchaObj.appendTo("#captcha")
			.onReady(function () {
			})
			.onSuccess(() => {
				var result = window.captchaObj.getValidate()
				const { countryCode, phone } = this.state
				var params = new FormData()
				Object.keys(result).map(item => {
					if (item == 'captchaId' || item == 'captcha_output' || item == 'gen_time' || item == 'lot_number' || item == 'pass_token') {
						params.append(item, result[item])
					}
				})
				params.append('mobilephone', phone)
				params.append('countryCode', countryCode)
				sendVerifyCodeNew(params).then(res => {
					if (res.flag) {
						this.setState({
							verityTime: 59,
							sendVerity: 1,
							registerWarnTips: intl.get('seller_sendphoneveritycode_tips')
						}, () => {
							setTimeout(() => {
								this.setState({
									registerWarnTips: ''
								})
							}, 3000)
							this.timer = setInterval(() => {
								if (this.state.verityTime != 0) {
									this.setState({
										verityTime: this.state.verityTime - 1
									})
								} else {
									clearInterval(this.timer)
								}
							}, 1000)
						})
					} else {
						this.setState({
							registerWarnTips: res.msg
						}, () => {
							setTimeout(() => {
								this.setState({
									registerWarnTips: ''
								})
							}, 3000)
						})
					}
				}).catch(err => err)
			})
	}

	componentDidMount() {
		document.getElementsByTagName('body')[0].setAttribute('spm-b', 'registerStep1')
		if(getCookie('seller_site_lang').split('-')[0] == 'zh'){
			document.getElementsByTagName("title")[0].innerText='敦煌网卖家注册 - 快速注册成为敦煌网卖家，轻松实现在线外贸';
			document.getElementsByName("description")[0].content = '在敦煌网快速注册成为卖家，轻松把产品批发到国外，实现在线外贸致富梦想'
			document.getElementsByName("keywords")[0].content = '快速注册，卖家注册，批发商注册，供应商注册，在线外贸，产品批发'
		} else {
			document.getElementsByTagName("title")[0].innerText='DHGate Seller Registration - Quickly register as a seller of DHgate and easily realize online foreign trade.'
			document.getElementsByName("description")[0].content = 'Quickly register as a seller on DHGate, easily wholesale products to foreign countries, and realize the dream of getting rich through online foreign trade'
			document.getElementsByName("keywords")[0].content = 'Quick registration, seller registration, wholesaler registration, supplier registration, online foreign business, product wholesale'
		}
		wechatCode().then(res => {
			this.setState({
				chatImg: res.code
			})
		}).catch(err => err)
		this.setState({
			registerVisible: true
		}, () => {
			this.asyncExposeBanner()
		})
		new Swiper(".swiper-container", {
			slidesPerView: 1,
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 2000,
				disableOnInteraction: false,
			},
			observer: true,
			observeParents: true,
			pagination: {
				el: ".swiper-pagination",
				type: 'bullets',
				clickable: true
			},
		})
		setTimeout(()=>{
			this.asyncBDSdk()
			this.asyncGoogleSdk()
		},500)
	}

	asyncBDSdk(){
		var _bdhmProtocol = document.createElement('script'); _bdhmProtocol.type = 'text/javascript'; _bdhmProtocol.async = true;
		_bdhmProtocol.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + '//hm.baidu.com/h.js?9eef9fc5580910cec1b91f7a0b6d273f';
		var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(_bdhmProtocol, s);
		window.onload = function() {
			var theBdimages = document.images
			for ( var i = 0, len = theBdimages.length; i < len; i++ ) {
				if ( theBdimages[i].src == '//eiv.baidu.com/hmt/icon/21.gif' ) {
					theBdimages[i].parentNode.style.display = 'none';
					break;
				}
			}
		}
	}

	asyncGoogleSdk(){
		var _gaq = _gaq || [];
		_gaq.push(
						['_setAccount', 'UA-425001-1'],
						['_setDomainName', '.dhgate.com'],
						['_addOrganic','haosou.com','q'],
			['_addOrganic','so.com','q'],
						['_trackPageview']
		);
		(function() {
		var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
		ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'stats.g.doubleclick.net/dc.js';
		var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
		})();
	}

	asyncExposeBanner(){
		//swiper-slide
		setTimeout(() => {
			var bannerList = document.getElementsByClassName('swiper-slide');
			for(var i=0;i<bannerList.length;i++){
				var elem = bannerList[i];
				if (window.__exposureBuryingPoint) {
					window.__exposureBuryingPoint.init({
						module: elem,
						moduleName: 'banner',
						spm_b: 'registerStep1',
						moduleIndex: elem.getAttribute('spm-index') || "1",
						event_body: {
							event_code: elem.getAttribute('event-code'),
							event_data: {
								event_entity_info: {
									link_type: elem.getAttribute('link-type') || 'item'
								}
							}
						}
					});
				}
			}

		},300)
	}



	asyncImportJs() {
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("script")[0];
				s.type = "text/javascript";
				s.src = "https://js.dhresource.com/seller/common/jquery.js";
				x.parentNode.insertBefore(s, x);
			} catch (e) { }
		})();
	}

	handleInputChange(ename, edata, e) {
		if (ename == 'focus') {
			this.setState({
				focusFlag: edata == 'phonenum' ? 'phonenum' : 'veritycode'
			})
		} else if (ename == 'blur' || ename == 'change') {
			if (edata == 'phonenum') {
				this.setState({
					focusFlag: ename == 'blur' ? '' : 'phonenum',
					phone: e.target.value
				}, () => {
					this.chkPhone()
				})
			} else {
				this.setState({
					focusFlag: ename == 'blur' ? '' : 'veritycode',
					verityCode: e.target.value,
					verityCodeErrTips: e.target.value ? '' : intl.get('seller_veritycode_empty')
				})
			}
		}
	}
	chkPhone() {
		const { phone, countryCode } = this.state
		if (!phone) {
			this.setState({
				phoneErrTips: intl.get('seller_register_phoneplaceholder')
			})
		} else {
			if (!validateMobile(countryCode, phone)) {
				this.setState({
					phoneErrTips: intl.get('seller_phonecode_formaterror')
				})
			} else {
				this.setState({
					phoneErrTips: ''
				})
			}
		}
	}

	handleSendVerityCodeBtnClick() { //发送验证码之前校验 账号是否违规和关联超限 否则不予发送验证码
		const { phone, countryCode } = this.state
		var params = new FormData()
		params.append('phone', phone)
		checkPhoneEmailValid(params).then(res => {
			if (res.flag) {
				window.captchaObj.showCaptcha();
				setTimeout(() => {
					var elem = document.getElementById('captcha')
					if (window.__exposureBuryingPoint) {
						window.__exposureBuryingPoint.init({
							module: elem,
							moduleName: 'registerinfo',
							spm_b: 'registerStep1',
							moduleIndex: elem.getAttribute('spm-index') || "1",
							event_body: {
								event_code: elem.getAttribute('event-code'),
								event_data: {
									event_entity_info: {
										link_type: elem.getAttribute('link-type') || 'item'
									}
								}
							}
						});
					}
				}, 300)
			} else {
				this.setState({
					limitFlag: res.type,
					limitType: res.rgstType == '1' ? intl.get('seller_individual_account') : intl.get('seller_enterprise_account'),
					limitNum: res.rgstCount,
					modalVisible: true
				}, () => {
					setTimeout(() => {
						var elem = document.getElementById('register-modal')
						if (window.__exposureBuryingPoint) {
							window.__exposureBuryingPoint.init({
								module: elem,
								moduleName: 'registerinfo',
								spm_b: 'registerStep1',
								moduleIndex: elem.getAttribute('spm-index') || "1",
								event_body: {
									event_code: elem.getAttribute('event-code'),
									event_data: {
										event_entity_info: {
											link_type: elem.getAttribute('link-type') || 'item'
										}
									}
								}
							});
						}
					}, 300)
				})
			}
		}).catch(err => err)
	}

	handleChangeRegisterBtnClick(data) {
		this.setState({
			registerType: data
		}, () => {
			if(data=='erweima'){
				this.timer = setInterval(() => {
					wechatCodeValid().then(res => {
						if(res.flag){
							this.setState({
								registerType: 'manaul'
							}, () => {
								clearInterval(this.timer)
							})
						}
					}).catch(err => err)
				}, 2000);
			} else {
				clearInterval(this.timer)
			}
		})
	}

	componentWillUnmount(){
		clearInterval(this.timer)
	}

	handleModalClose() {
		this.setState({
			modalVisible: false
		})
	}

	handleModalTipsClose(val) {
		this.setState({
			registerVisible: val
		})
	}

	handleSwiperItemClick(val){
		window.open(val,'_blank')
	}

	render() {
		const { registerVisible, focusFlag, registerType, verityTime, phone, countryAreacode, phoneErrTips, modalVisible, limitFlag, limitType, limitNum, registerWarnTips, verityCodeErrTips, noverityVisible, bannerData, verityCode,chatImg, isColumbusSeller } = this.state
		var currentLang = getCookie('seller_site_lang') ? getCookie('seller_site_lang').split('-')[0] : 'zh'
		return (
			<div className='main-container'>
				<div className='main-container-header'>
					<ExternalFiles data={{ uri: `//seller.dhgate.com/header-${currentLang}-register-2023.html`, params: {}, staticRes: '' }}></ExternalFiles>
				</div>
				<div className='container-box'>
					<div className='register-header'>
						<div className='register-header-item register-header-item-active'>
							<span className='register-header-item-label'>1</span>
							<span className='register-header-item-desc'>{intl.get('seller_register_step1')}</span>
						</div>
						<div className='register-header-item register-header-item-step2'>
							<span className='register-header-item-label'>2</span>
							<span className='register-header-item-desc'>{intl.get('seller_register_step2')} <br />
								<b>{intl.get('seller_register_step2_tips')}</b>
							</span>
						</div>
						<div className='register-header-item'>
							<span className='register-header-item-label'>3</span>
							<span className='register-header-item-desc'>{intl.get('seller_register_step3')}</span>
						</div>
						<div className='register-header-item-activeborder'>

						</div>
					</div>
					<div className='register-content'>
						<div className='register-content-left swiper-container'>
							<div className="swiper-wrapper" >
								{bannerData.map((item, index) => {
									return (
										<div className="swiper-slide" key={index} target="_blank" event-type="expose" spm-c="banner" async-exposure="true"
										spm-index={index+1}>
											{item.linkUrl ? (
												<span
													onClick={this.handleSwiperItemClick.bind(this,item.linkUrl )}
													style={{ cursor:'pointer' }}
												>
													<img
														width="100%"
														src={currentLang=='zh'?item.imageUrl:item.imageUrlEn}
														alt=""
													/>
												</span>
											) : ''
											}
										</div>
									);
								})}
								{/* 分页器 */}
							</div>
							<div className="swiper-pagination"></div>
						</div>
						<div className='register-content-right' style={{ paddingTop:registerType == 'manaul'?'75px':'55px'}}>
							{
								registerType == 'manaul' ?
									<>
										<p className='register-warntips' style={{ visibility: registerWarnTips?'visible': 'hidden' }}><img src={WarnIcon} alt='' />{registerWarnTips}</p>
										<p className='register-content-right-titlelabel'>{intl.get('seller_register_phonelabel')}</p>
										<p className='register-content-right-textarea-country' style={{ borderColor: focusFlag == 'phonenum' ? '#ffcb05' : phoneErrTips ? 'red' : '#ccc' }}>
											<CountrySelect changeCountry={this.handleCountryChange} />
											<Input className='register-content-right-text-phonenumber' onFocus={this.handleInputChange.bind(this, 'focus', 'phonenum')} onBlur={this.handleInputChange.bind(this, 'blur', 'phonenum')} onChange={this.handleInputChange.bind(this, 'change', 'phonenum')} allowClear={{clearIcon: <img src={DelIcon} alt="" />}} />
										</p>
										<p className='error-tips' style={{ visibility: phoneErrTips?'visible': 'hidden' }}>{phoneErrTips}</p>
										<p className='register-content-right-titlelabel' style={{ marginTop: '30px' }}>{intl.get('seller_register_phonecodelabel')}
											{
												(verityTime == '60' || verityTime == '0') && phone && !phoneErrTips ?
													'' :
													verityTime == '60' || verityTime == '0' ? '' : <span className='register-content-right-noveritycode' onClick={this.handleNoverityCodeClick} event-type="click" spm-c="registerinfo" spm-index="notreceived">{intl.get('seller_cannot_getcode')}</span>
											}
										</p>
										<p className='register-content-right-textarea-phonecode' style={{ borderColor: focusFlag == 'veritycode' ? '#ffcb05' : verityCodeErrTips ? 'red' : '#ccc' }}>
											<Input className='register-content-right-text-veritycode' placeholder={intl.get('seller_register_code_placeholder')} onFocus={this.handleInputChange.bind(this, 'focus', 'veritycode')} onBlur={this.handleInputChange.bind(this, 'blur', 'veritycode')} onChange={this.handleInputChange.bind(this, 'change', 'veritycode')} allowClear={{clearIcon: <img src={DelIcon} alt="" />}} />
											{
												(verityTime == '60' || verityTime == '0') && phone && !phoneErrTips ?
													<span className='register-content-right-sendveritycode' onClick={this.handleSendVerityCodeBtnClick} event-type="click" spm-c="registerinfo" spm-index="sendCode">{intl.get('seller_sendveritycode')}</span> :
													verityTime == '60' || verityTime == '0' ? <span className='register-content-right-resendveritycode'>{intl.get('seller_sendveritycode')}</span> : <span className='register-content-right-resendveritycode'>{intl.get('seller_resendveritycode')}({verityTime}{intl.get('seller_resend_unit')})</span>
											}
										</p>
										<p className='error-tips' style={{ visibility: verityCodeErrTips?'visible': 'hidden' }}>{verityCodeErrTips}</p>
										<div
											id="captcha"
											className={` ${this.captchaConfig.config.product === 'bind' ? "hideHeight" : null}`}
											async-exposure="true"
											event-type="expose"
											spm-b="registerStep1"
											spm-c="registerinfo"
											spm-index="swipetoverify"
										>
											<GeetestCaptcha captchaConfig={this.captchaConfig} />
										</div>
										{
											phone && !verityCodeErrTips && !phoneErrTips && verityCode ? <div className='register-btn' onClick={this.handleRegisterBtnClick} event-type="click" spm-c="registerinfo" spm-index="signup">
												{intl.get('seller_register_step1')}
											</div> : <div className='register-btn-disable'>
												{intl.get('seller_register_step1')}
											</div>
										}
										<p className='register-tips'>{intl.get('seller_register_hasaccount')}<span className='register-tologin-btn' onClick={this.handleLoginBtnClick} event-type="click" spm-c="registerinfo" spm-index="signin">{intl.get('seller_login_btn')}</span></p>
									</> :
									<>
										<p className='register-erweima-title'>{intl.get('seller_register_title')}</p>
										<p className='register-erweima-img'>
											<img src={chatImg} alt='' />
										</p>
										<p className='register-erweima-tomanaul' onClick={this.handleChangeRegisterBtnClick.bind(this, 'manaul')}>{intl.get('seller_register_tips')}</p>
									</>
							}
							{/* <p className='register-changetype-btn'>
								{
									registerType == 'manaul' ?
										<img src={RegisterErWeiMa} alt='' onClick={this.handleChangeRegisterBtnClick.bind(this, 'erweima')} /> :
										<img src={RegisterManaul} alt='' onClick={this.handleChangeRegisterBtnClick.bind(this, 'manaul')} />
								}
							</p> */}
						</div>
					</div>
					<ConnectUs isColumbusSeller={isColumbusSeller} spmB="registerStep1" spmC="contactinfo" />
					<TipsDialog visible={registerVisible} handleCloseModal={this.handleModalTipsClose.bind(this)} />
				</div>
				<ExternalFiles data={{ uri: `//seller.dhgate.com/syihtml/footer-${currentLang}-2023.html`, params: {}, staticRes: '' }}></ExternalFiles>
				<Modal title={limitFlag == '1' ? intl.get('seller_relation_violation_title') : intl.get('seller_relation_overrun_title')} style={{ borderRadius: "25px", overflowX: "auto" }} width='550px' closeIcon={<img src={CloseIcon} />} visible={modalVisible} onCancel={this.handleModalClose} centered={true} maskClosable={false} zIndex={10000} destroyOnClose={true} footer={[
					<span className='modal-registerstep1-confirmbtn modal-registerstep1-confirmbtn-active' onClick={this.handleModalClose}>
						{intl.get('seller_modal_ok')}
					</span>
				]}>
					<div className='register-modal-content' id='register-modal' async-exposure="true" event-type="expose" spm-c="registerinfo" spm-index={limitFlag == '1' ? 'accountViolations' : 'accountExceeds'}>
						{
							limitFlag == '1' ? <p>
								{intl.get('seller_relation_violation_tips', { "phone": `${countryAreacode} ${phone}` })}
							</p> :
								<p>
									{intl.get('seller_relation_overrun_tips', { "phone": `${countryAreacode} ${phone}`, "num": limitNum, "type": limitType })}
								</p>
						}
						<p>{intl.get('seller_realtion_updatephone_tips')}</p>
						<a href='https://seller.dhgate.com/help/c0101/351401.html#university-helpCont-5' target="_blank" spm-index="reviewPolicy">{intl.get('seller_relation_policylink')}&gt;&gt;</a>
					</div>
				</Modal>
				<Modal title={intl.get('seller_cannot_getcode')} style={{ borderRadius: "25px", overflowX: "auto" }} closeIcon={<img src={CloseIcon} />} width='550px' visible={noverityVisible} onCancel={this.handleVerityModalClose} centered={true} maskClosable={false} zIndex={10000} destroyOnClose={true} footer={[
					<span className='modal-registerstep1-confirmbtn modal-registerstep1-confirmbtn-active' onClick={this.handleVerityModalClose}>
						{intl.get('seller_modal_ok')}
					</span>
				]}>
					<div className='register-modal-content'>
						<p>{intl.get('seller_noveritycode_tips')}</p>
					</div>
				</Modal>
			</div>
		)
	}
}
export default Register